import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
// styles
import styles from './styles.module.scss';
import { Video } from 'react-feather';
import api from '@/api';
import { makeSelectEventById } from '@/models/event';
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';
import { Trans, useTranslation } from 'react-i18next';

const AfterEventSection = ({ buttonStyle }) => {
  const { eventId } = useParams<{ eventId: string }>();
  const [showRecordingsButton, setShowRecordingsButton] = useState(false);
  const event = useMemoizedSelector(makeSelectEventById, eventId);

  const { t } = useTranslation();

  useEffect(() => {
    if (!event?.eventId) return;
    // Hiding view recordings button for below organization in prod
    if (event.organizationId === '1ef49ce5-c34f-4650-b10b-a8da96db3469') {
      setShowRecordingsButton(false);
      return;
    }
    api.recording.getRecordingsCountPublic(eventId).then(({ data }) => {
      if (data && data >= 1) {
        setShowRecordingsButton(true);
      }
    });
  }, [event]);

  return (
    <>
      <div className={styles.outerSectionContainer}>
        <div className={styles.innerSectionContainer}>
          <DisappointedIcon />
        </div>
      </div>
      <div className={styles.mainHeading}>
        {t('landing_page.uh_oh', 'Uh Oh!')}
      </div>
      <div className={styles.heading}>
        <Trans
          i18nKey="landing_page.event_join_ended"
          defaults="The event you're trying to join <0></0> has ended"
          components={[<br />]}
        />
      </div>
      {showRecordingsButton && (
        <>
          <div className={styles.heading}>
            {t(
              'landing_page.check_out_recordings',
              'But we’ve got you covered. Check out event recordings.',
            )}
          </div>
          <Link
            className={styles.viewRecordsButton}
            style={buttonStyle}
            target="_blank"
            to={`/event/${eventId}/stageRecordings`}
          >
            <Video />
            &nbsp;&nbsp; {t('landing_page.view_recordings', 'View Recordings')}
          </Link>
        </>
      )}
    </>
  );
};

export default AfterEventSection;

const DisappointedIcon = () => (
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.7743 3.79028C27.326 3.79028 34.2581 10.7224 34.2581 19.2742C34.2619 21.6919 33.697 24.0766 32.6091 26.2357C32.4955 25.7949 32.285 25.3849 31.9929 25.0357L31.8024 24.8267L29.613 22.6372L27.4236 24.8267L27.2424 25.0233C26.8501 25.4896 26.6041 26.0614 26.5352 26.6669C26.4663 27.2724 26.5776 27.8848 26.8552 28.4273C27.1327 28.9698 27.5642 29.4184 28.0955 29.7169C28.6268 30.0153 29.2344 30.1504 29.8421 30.1051C28.4014 31.5803 26.6798 32.752 24.7789 33.5511C22.878 34.3503 20.8363 34.7606 18.7743 34.758C10.2225 34.758 3.29041 27.8259 3.29041 19.2742C3.29041 10.7224 10.2225 3.79028 18.7743 3.79028ZM18.7743 23.9193C16.6375 23.9193 14.702 24.7864 13.3023 26.1846L13.0452 26.454L14.5085 27.7856C15.7317 27.2979 17.198 27.0161 18.7743 27.0161C20.1756 27.0161 21.4901 27.2391 22.6236 27.6292L23.0401 27.7841L24.5033 26.4525C23.7783 25.6534 22.894 25.0152 21.9072 24.5789C20.9204 24.1426 19.8532 23.9179 18.7743 23.9193ZM13.3549 16.1774C12.7389 16.1774 12.1482 16.4221 11.7126 16.8576C11.277 17.2932 11.0323 17.884 11.0323 18.5C11.0323 19.1159 11.277 19.7067 11.7126 20.1423C12.1482 20.5778 12.7389 20.8225 13.3549 20.8225C13.9709 20.8225 14.5617 20.5778 14.9972 20.1423C15.4328 19.7067 15.6775 19.1159 15.6775 18.5C15.6775 17.884 15.4328 17.2932 14.9972 16.8576C14.5617 16.4221 13.9709 16.1774 13.3549 16.1774ZM24.1936 16.1774C23.5776 16.1774 22.9869 16.4221 22.5513 16.8576C22.1157 17.2932 21.871 17.884 21.871 18.5C21.871 19.1159 22.1157 19.7067 22.5513 20.1423C22.9869 20.5778 23.5776 20.8225 24.1936 20.8225C24.8096 20.8225 25.4004 20.5778 25.8359 20.1423C26.2715 19.7067 26.5162 19.1159 26.5162 18.5C26.5162 17.884 26.2715 17.2932 25.8359 16.8576C25.4004 16.4221 24.8096 16.1774 24.1936 16.1774Z" fill="#484848" />
  </svg>
);
